<section class="co-callender u-bg2">
  <div class="c-wrapper--medium">
    @if (bannerPc() || bannerSp()) {
    <div class="co-banner">
      @if (bannerPc()) {
      <img class="u-dn u-db-md" [src]="bannerPc()" alt="バナー">
      }
      @if (bannerSp()) {
      <img class="u-dn-md" [src]="bannerSp()" alt="バナー">
      }
    </div>
    }

    @if (!isCasual()) {
      <h2 class="co-callender__title">カウンセリング方法を選んでください</h2>
      <mat-radio-group [ngModel]="place()" (ngModelChange)="place.set($event)">
        @if (isCasual()) {
          <mat-radio-button value="カジュアル面談"><span class="co-callender__label  u-br-normal u-text-bold">カジュアル面談</span></mat-radio-button>
        } @else {
          <mat-radio-button value="新宿オフィス"><span class="co-callender__label  u-br-normal u-text-bold">新宿オフィスでの対面相談</span><button class="co-callender__detailBtn u-br-normal" (click)="openMap()">詳細</button></mat-radio-button>
          <mat-radio-button value="オンライン"><span class="co-callender__label u-br-normal u-text-bold">オンライン面談</span></mat-radio-button>
        }
      </mat-radio-group>
      <div class="attention-box">
        <div><span>{{ expirationCountdown() }}</span><span>予約枠を確保中</span></div>
        <div>
          このままご予約いただくと、<br />
          最大{{ discount() }}万円の割引が適用されます。
        </div>
      </div>
    }

    <h2 class="co-callender__title">ご希望の日時をタップしてください</h2>
    @if (!isColorful()) {
      <p class="co-callender__note u-lh-1">〇：空席あり　△：残り5枠以下</p>
    }
    @if (schedules().length) {
      <table class="co-callender__table" id="schedules" [class.colorful]="isColorful()">
        <tbody>
          <tr class="co-callender__dateWrapper">
            <th class="co-callender__date u-text-center"></th>
            @for (date of schedules(); track date) {
            <th class="co-callender__date u-text-center">{{ date.day|date:'M/dd' }}<br class="u-db u-dn-md">({{ date.day|date:'E' }})</th>
            }
          </tr>
          @for (schedule of schedules()[0].schedules; track schedule; let i = $index) {
            <tr class="co-callender__tr">
              <th class="co-callender__time u-text-center">{{ schedule.time|slice:0:5 }}</th>
              @for (date of schedules(); track date) {
              <td class="co-callender__status u-text-center" [class.selected]="selectedDate()?.date === date.day && selectedDate()?.time === schedule.time">
                @if (date.schedules[i].status === '-' || date.schedules[i].status === '×') {
                <div class="empty">{{ isColorful() ? '満 席' : date.schedules[i].status }}</div>
                } @else if (selectedDate()?.date === date.day && selectedDate()?.time === schedule.time) {
                <a class="co-callender__link u-br-normal" (click)="select($event, date.day, schedule.time)">選択中</a>
                } @else if (isColorful()) {
                  <a href="#step" class="co-callender__link u-br-normal remain" (click)="select($event, date.day, schedule.time)">
                    残り<br />{{ date.schedules[i].remain }} 枠
                  </a>
                } @else {
                <a href="#step" class="co-callender__link u-br-normal" [class.few]="date.schedules[i].status === '△'" (click)="select($event, date.day, schedule.time)">
                  {{ date.schedules[i].status }}
                  @if (date.schedules[i].status === '△') {
                  <br /><span>残り{{ date.schedules[i].remain }}枠</span>
                  }
                </a>
                }
              </td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (!isCasual()) {
        <div class="attention">空席がない場合は<br>「次の1週間」をタップしてご確認ください。</div>
      }
    } @else {
      Loading...
    }
    @if (!isCasual()) {
      <div class="co-callender__pnwrapper">
        <a class="co-callender__prev u-br-normal u-text-bold" (click)="prevWeek()" [class.disabled]="!canPrev()">前の1週間</a>
        <a class="co-callender__next u-br-normal u-text-bold" (click)="nextWeek()">次の1週間</a>
      </div>
    }
  </div>
</section>
@if (hasComplete()) {
  <div class="u-text-center">
    <button class="co-form__btn u-br-normal c-btn c-btn--ac1" type="button" name="submitConfirm" value="{{ isCasual() ? '電話' : '無料' }}カウンセリングを予約する" (click)="submit()" [disabled]="sending()">予約する</button>
  </div>
}

